/* MCC campaigns: keeps the running campaign up to date while the page is open, fills the countdowns
   and shows the campaign popup once per visitor per campaign. The first pick happens inline in <head>
   (snippets/mcc-campaign.liquid) so nothing jumps when the page loads. */
(function () {
  'use strict';
  var root = document.documentElement;
  var testMode = !!(window.Shopify && ((Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || Shopify.designMode));

  function now() {
    return Date.now() + (window.MCC_OFFSET || 0);
  }

  function pick() {
    var list = window.MCC_CAMPAIGNS || [];
    var t = now();
    var best = null;
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      if (t >= c.s && t <= c.e && (!best || c.p > best.p || (c.p === best.p && c.s > best.s))) best = c;
    }
    return best;
  }

  function apply(best) {
    var current = window.MCC_ACTIVE || null;
    if ((current && current.h) === (best && best.h)) return;
    if (current) root.classList.remove('mcc-on-' + current.h);
    if (best) {
      root.classList.add('mcc-campaign-on', 'mcc-on-' + best.h);
    } else {
      root.classList.remove('mcc-campaign-on');
    }
    window.MCC_ACTIVE = best;
  }

  function format(ms) {
    if (!(ms > 0)) return '';
    var minutes = Math.floor(ms / 60000);
    var days = Math.floor(minutes / 1440);
    var hours = Math.floor((minutes % 1440) / 60);
    var mins = minutes % 60;
    if (days > 0) return 'Ends in ' + days + 'd ' + hours + 'h';
    if (hours > 0) return 'Ends in ' + hours + 'h ' + mins + 'm';
    return 'Ends in ' + Math.max(mins, 1) + 'm';
  }

  function tick() {
    apply(pick());
    var t = now();
    var nodes = document.querySelectorAll('[data-mcc-end]');
    for (var i = 0; i < nodes.length; i++) {
      var text = format(Number(nodes[i].getAttribute('data-mcc-end')) - t);
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
  }

  var store = (function () {
    try {
      return testMode ? window.sessionStorage : window.localStorage;
    } catch (error) {
      return null;
    }
  })();

  function seen(handle) {
    try {
      return !!store && store.getItem('mcc_pop_' + handle) === '1';
    } catch (error) {
      return false;
    }
  }

  function markSeen(handle) {
    try {
      if (store) store.setItem('mcc_pop_' + handle, '1');
    } catch (error) {}
  }

  var newsletterSeen = false;

  function newsletterIsOpen(el) {
    return el.hasAttribute('open') || el.classList.contains('open') || el.classList.contains('active') || el.classList.contains('is-open');
  }

  function watchNewsletter() {
    var el = document.querySelector('subscription-popup');
    if (!el || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (newsletterIsOpen(el)) newsletterSeen = true;
    }).observe(el, { attributes: true });
  }

  function popupAllowed() {
    var body = document.body;
    if (!body || (window.Shopify && Shopify.designMode)) return false;
    return !/(^|\s)(product|cart|password|gift_card|customers\/[a-z_]+)-template(\s|$)/.test(body.className);
  }

  function openPopup() {
    var active = window.MCC_ACTIVE;
    if (!active || !active.pop || seen(active.h) || !popupAllowed() || newsletterSeen) return;
    var newsletter = document.querySelector('subscription-popup');
    if (newsletter && newsletterIsOpen(newsletter)) return;
    var el = document.querySelector('[data-mcc-pop="' + active.h + '"]');
    if (!el) return;
    markSeen(active.h);
    var stickyBar = document.querySelector('mobile-sticky-bar');
    var offset = 0;
    if (stickyBar && window.getComputedStyle(stickyBar).display !== 'none' && window.getComputedStyle(stickyBar).position === 'fixed') {
      offset = Math.round(stickyBar.getBoundingClientRect().height);
    }
    el.style.setProperty('--mcc-pop-bottom', offset + 'px');
    el.classList.add('is-open');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
    });
    function close() {
      el.classList.remove('is-visible');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () {
        el.classList.remove('is-open');
      }, 300);
    }
    function onKey(event) {
      if (event.key === 'Escape') close();
    }
    var button = el.querySelector('[data-mcc-pop-close]');
    if (button) button.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  function init() {
    tick();
    window.setInterval(tick, 30000);
    watchNewsletter();
    window.setTimeout(openPopup, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
